export const matchesScrV2Id = (left, right) =>
  Boolean(left && right && String(left).toLowerCase() === String(right).toLowerCase());

export const resolveInitialScrV2Report = ({
  scrId,
  location,
  reduxReport,
  previewStateKey,
  peekCache,
  isComplete,
  normalize,
}) => {
  const cached = peekCache(scrId);
  if (cached && matchesScrV2Id(cached.scrId, scrId)) {
    return normalize(cached, scrId);
  }

  if (
    reduxReport?.scrId &&
    matchesScrV2Id(reduxReport.scrId, scrId) &&
    isComplete(reduxReport)
  ) {
    return normalize(reduxReport, scrId);
  }

  const preview = location?.state?.[previewStateKey];
  if (preview && matchesScrV2Id(preview.scrId ?? scrId, scrId)) {
    return normalize({ ...preview, scrId: preview.scrId ?? scrId }, scrId);
  }

  return { scrId };
};
